/** Country list for international applications / checkout (ISO-ish, native names). */
export const COUNTRIES: string[] = [
  'Türkiye',
  'Deutschland',
  'France',
  'Nederland',
  'België',
  'Schweiz',
  'Österreich',
  'United Kingdom',
  'United States',
  'Canada',
  'Russia',
  'Ukraine',
  'Azerbaijan',
  'Kazakhstan',
  'United Arab Emirates',
  'Saudi Arabia',
  'Qatar',
  'Kuwait',
  'Bahrain',
  'Oman',
  'Jordan',
  'Lebanon',
  'Egypt',
  'Morocco',
  'Iraq',
  'Iran',
  'Georgia',
  'Bulgaria',
  'Greece',
  'Romania',
  'Italy',
  'Spain',
  'Portugal',
  'Poland',
  'Sweden',
  'Norway',
  'Denmark',
  'Finland',
  'Australia',
  'India',
  'Other',
];